'use strict';

var buildNumberUnitMethods = require('../internal/buildNumberUnitMethods');

buildNumberUnitMethods();


// WEBPACK FOOTER //
// ./~/sugar-date/date/build/buildNumberUnitMethodsCall.js